import React from 'react';
import PropTypes from 'prop-types';
import { formatMonthDay } from '../../helpers/dateTimeHelpers';
import classNames from 'classnames';
import EtaIcon from '../../../icons/eta.svg';
import {Heading} from '../StyledComponents';
import styles from './ETA.module.scss';

class ETA extends React.PureComponent {
  render() {
    const {
      estimatedArrival,
      includeDayOfWeek,
      isMobile,
      designSettings: {
        etaBackgroundColor: backgroundColor,
        etaTextColor: color,
        etaIconColor: fill,
        headingFontSize,
        headingFont,
      },
      locale,
      etaLabel,
    } = this.props;

    return (
      <div styleName={classNames('eta', { mobile: isMobile })} style={{ backgroundColor }}>
        <EtaIcon styleName="icon" style={{ fill }} />
        <div styleName="info" style={{ color }}>
          <div styleName="title">
            <Heading
              type="headingTertiary"
              fontSize={headingFontSize}
              font={headingFont}
              isMobile={isMobile}
            >
              {etaLabel}
            </Heading>
          </div>
          <div className={styles.time}>
            <Heading
              type="headingPrimary"
              fontSize={headingFontSize}
              font={headingFont}
              isMobile={isMobile}
            >
            { formatMonthDay(locale, new Date(estimatedArrival), includeDayOfWeek) }
            </Heading>
          </div>
        </div>
      </div>
    );
  }
}

ETA.propTypes = {
  estimatedArrival: PropTypes.string.isRequired,
  includeDayOfWeek: PropTypes.bool,
  isMobile: PropTypes.bool,
  designSettings: PropTypes.shape({
    headingFont: PropTypes.string,
    headingFontSize: PropTypes.string,
    etaBackgroundColor: PropTypes.string,
    etaTextColor: PropTypes.string,
    etaIconColor: PropTypes.string,
  }),
  locale: PropTypes.string,
};

export default ETA;
